import React from 'react';
import { ListFieldSection } from '../../../Layout';
import { withInjectedProps, NamePrefixModifier } from '../../../Core/InjectedPropsContext';
import { Checkbox, Field, TextOutput } from '../../../Core';
import { WorksheetResultsSection, WorksheetsResultsMessagesSection, IWithWorksheetInjectedProps } from '../../Core';
import { useSelector } from 'react-redux';
import AtterbergLimitChartSection from './ChartSection';
import { combine, pipe } from 'Lib/Hooks/Selectors';
import { hasNonEmptyValue, valueOrDefault } from 'Lib/Any';

const contextCaptions = [
  { path: `data.LiquidLimit.Trials`, caption: 'Liquid Limit' },
  { path: `data.PlasticLimit.Trials`, caption: 'Plastic Limit' },
  { path: `data.Preparation.AssociatedAsReceivedWaterContent`, caption: 'As-Received Water Content' },
];

let ResultsSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const llNonPlastic = useSelector(pipe(createWorksheetSelector!('LiquidLimit.NonPlastic'), valueOrDefault(false)));
  const plNonPlastic = useSelector(pipe(createWorksheetSelector!('PlasticLimit.NonPlastic'), valueOrDefault(false)));
  const testForOrganics = useSelector(
    pipe(createWorksheetSelector!('Preparation.TestForOrganics'), valueOrDefault(false))
  );
  const hasAdditionalVisualDescription = useSelector(
    combine(
      ['Preparation.AdditionalVisualDescriptionRequired', 'Preparation.AdditionalVisualDescription'].map((n) =>
        createWorksheetSelector!(n)
      ),
      (isRequired, description) => isRequired && hasNonEmptyValue(description)
    )
  );

  return (
    <WorksheetResultsSection heading="Results">
      <NamePrefixModifier namePrefix="plasticityChart">
        <AtterbergLimitChartSection wide visible={!llNonPlastic && !plNonPlastic} height={400} />
      </NamePrefixModifier>
      <WorksheetsResultsMessagesSection contextCaptions={contextCaptions} />
      <ListFieldSection heading="Results">
        <Field input={<TextOutput />} label="Liquid Limit" name="Results.LiquidLimitText" />
        <Field
          input={<TextOutput />}
          label="Liquid Limit (Oven Dry)"
          name="Results.LiquidLimitOvenDriedText"
          visible={testForOrganics}
        />
        <Field input={<TextOutput />} label="Plastic Limit" name="Results.PlasticLimitText" />
        <Field input={<TextOutput />} label="Plasticity Index" name="Results.PlasticityIndexText" />
        <Field input={<TextOutput />} label="Liquidity Index" name="Results.LiquidityIndexText" />
      </ListFieldSection>
      <ListFieldSection heading="Report" single>
        <Field input={<Checkbox />} label="Liquidity Index" name="Results.ReportLiquidityIndex" />
        <Field
          input={<Checkbox />}
          label="Visual Description"
          name="Results.ReportVisualDescription"
          disabled={!hasAdditionalVisualDescription}
        />
        <Field input={<Checkbox />} label="Specimen Preparation Details" name="Results.ReportPreparationDetails" />
        <Field input={<Checkbox />} label="Removal method for oversize material" name="Results.ReportOversizeRemoval" />
        <Field input={<Checkbox />} label="Liquid Limit equipment type" name="Results.ReportLLEquipmentType" />
        <Field input={<Checkbox />} label="Plastic Limit equipment type" name="Results.ReportPLEquipmentType" />
      </ListFieldSection>
    </WorksheetResultsSection>
  );
};

ResultsSection = withInjectedProps(ResultsSection);

export { ResultsSection };
export default ResultsSection;
